<template>
  <div v-if="isSuspended" class="suspended-alert">
    <v-icon color="#fff" small class="suspended-alert__icon">mdi-lock</v-icon>
    <div class="suspended-alert__body">
      <b>บริษัทถูกระงับการใช้งานชั่วคราว</b>
      <span class="suspended-alert__divider">·</span>
      <span>กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อเปิดใช้งานอีกครั้ง</span>
    </div>
    <a href="tel:0661105989" class="suspended-alert__phone">
      <v-icon color="#c9242b" x-small class="tw-mr-1">mdi-phone</v-icon>
      066-110-5989
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AlertCompanySuspended",
  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
    }),
    isSuspended() {
      return this.selectedCompany?.isSuspended === true;
    },
  },
};
</script>

<style lang="scss">
.suspended-alert {
  /* Laid out in flow inside .company-alerts (app-bar) so it stacks above the
     quota ribbon instead of overlapping it. */
  max-width: 100%;

  display: flex;
  align-items: center;
  gap: 12px;

  padding: 10px 18px;
  background: linear-gradient(90deg, #ef6c00 0%, #e65100 100%);
  color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(239, 108, 0, 0.25);
  font-size: 13px;
  line-height: 1.2;

  &__icon {
    flex-shrink: 0;
  }

  &__body {
    min-width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    /* ให้ข้อความไทยตัดขึ้นบรรทัดใหม่ได้เมื่อพื้นที่แคบ แทนการถูกตัดทิ้ง */
    overflow-wrap: anywhere;

    b {
      font-weight: 700;
    }
  }

  &__divider {
    opacity: 0.6;
  }

  &__phone {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    color: #c9242b;
    background: #ffffff;
    font-weight: 700;
    text-decoration: none;
    padding: 4px 12px;
    border-radius: 999px;
    white-space: nowrap;
    transition: transform 0.15s ease;

    &:hover {
      transform: translateY(-1px);
    }
  }

  /* จอแคบ: ซ่อนประโยครอง + จุดคั่นที่ค้าง เหลือแค่หัวข้อ + ปุ่มเบอร์โทร */
  @media only screen and (max-width: 1600px) {
    .suspended-alert__divider,
    .suspended-alert__body span:last-child {
      display: none;
    }
  }

  @media only screen and (max-width: 960px) {
    padding: 8px 14px;
  }
}
</style>
